import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import SignIn from '../SignIn'
import HomeAction from '../../../home/actions/HomeAction'
import AppStore from '../../../store/AppStore'
import Dialog from '@material-ui/core/Dialog'
import Slide from '@material-ui/core/Slide'

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ ref } { ...props } />
})

class LoginModal extends Component {
	handleClose = () => {
		AppStore.dispatch(HomeAction.updateLoginModalState(false))
	}

	render() {
		return (
			<Dialog
				maxWidth='xs'
				TransitionComponent={ Transition }
				modal={ false }
				keepMounted
				open={ this.props.loginModalState }
				onClose={ this.handleClose }
			>
				<SignIn actions={ this.props.modalActions }/>
			</Dialog>
		)
	}
}

LoginModal.propTypes = {
	loginModalState: PropTypes.bool,
	modalActions: PropTypes.func
}
const mapStateToProps = (store) => {
	return {
		loginModalState: store.HomeReducer.loginModalState,
		modalActions: store.HomeReducer.modalActions
	}
}
export default connect(mapStateToProps)(LoginModal)



// WEBPACK FOOTER //
// ./src/login/components/modal/LoginModal.js